// extracted by mini-css-extract-plugin
module.exports = {"textarea":"MetatagsSection_textarea__2NzIf","textareaContainer":"MetatagsSection_textareaContainer__1aAor"};